import { useFormContext } from 'react-hook-form'
import { FormField } from '@/components/serge/FormField'
import { type LegalEntityFormData } from '@/lib/legalEntitySchema'

export function ContactStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<LegalEntityFormData>()

  return (
    <div className="space-y-6">
      <div className="border border-border bg-surface p-5">
        <h3 className="text-lg font-semibold text-foreground mb-1">Contact & Siège social</h3>
        <p className="text-sm text-foreground-secondary mb-6">
          Coordonnées et adresse de l'entreprise
        </p>

        <div className="space-y-4">
          <FormField label="Adresse du siège social" error={errors.address?.line1}>
            <input
              {...register('address.line1')}
              className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
              placeholder="Numéro et nom de rue"
            />
          </FormField>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <FormField label="Code postal" error={errors.address?.postalCode}>
              <input
                {...register('address.postalCode')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground font-mono focus:outline-none focus:border-primary transition"
                placeholder="75001"
              />
            </FormField>

            <FormField label="Ville" error={errors.address?.city}>
              <input
                {...register('address.city')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="Paris"
              />
            </FormField>

            <FormField label="Pays" error={errors.address?.country}>
              <input
                {...register('address.country')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="France"
              />
            </FormField>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Email de contact"
              error={errors.contactEmail}
              tooltip="Adresse email principale pour contacter l'entreprise"
            >
              <input
                type="email"
                {...register('contactEmail')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="contact@exemple.fr"
              />
            </FormField>

            <FormField
              label="Téléphone"
              error={errors.contactPhone}
              tooltip="Numéro de téléphone principal"
            >
              <input
                type="tel"
                {...register('contactPhone')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="+33 1 23 45 67 89"
              />
            </FormField>
          </div>

          <FormField
            label="Site web"
            error={errors.website}
            tooltip="URL complète du site web (avec https://)"
          >
            <input
              type="url"
              {...register('website')}
              className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
              placeholder="https://exemple.fr"
            />
          </FormField>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField
              label="Représentant légal"
              error={errors.directorName}
              tooltip="Nom et prénom du dirigeant ou représentant légal"
            >
              <input
                {...register('directorName')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="Jean Dupont"
              />
            </FormField>

            <FormField
              label="Directeur de publication"
              error={errors.publicationDirector}
              tooltip="Responsable éditorial du site web (requis pour les mentions légales)"
            >
              <input
                {...register('publicationDirector')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="Jean Dupont"
              />
            </FormField>
          </div>
        </div>
      </div>

      <div className="border border-border bg-surface p-5">
        <h3 className="text-lg font-semibold text-foreground mb-1">Hébergeur web</h3>
        <p className="text-sm text-foreground-secondary mb-6">
          Informations sur l'hébergeur du site (obligatoire pour les mentions légales)
        </p>

        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <FormField label="Nom de l'hébergeur" error={errors.hostingProvider?.name}>
              <input
                {...register('hostingProvider.name')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="OVH, AWS, etc."
              />
            </FormField>

            <FormField label="Téléphone" error={errors.hostingProvider?.phone}>
              <input
                type="tel"
                {...register('hostingProvider.phone')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="+33 1 23 45 67 89"
              />
            </FormField>

            <FormField label="Email" error={errors.hostingProvider?.email}>
              <input
                type="email"
                {...register('hostingProvider.email')}
                className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
                placeholder="support@hebergeur.fr"
              />
            </FormField>
          </div>

          <FormField label="Adresse de l'hébergeur" error={errors.hostingProvider?.address}>
            <input
              {...register('hostingProvider.address')}
              className="w-full border border-border bg-bg p-3 text-sm text-foreground focus:outline-none focus:border-primary transition"
              placeholder="Adresse complète"
            />
          </FormField>
        </div>
      </div>
    </div>
  )
}
